const getcode = function (elem) {
    if (!elem) {
        elem = document;
    }
    const hljsElements = elem.getElementsByClassName('hljs');
    for (let i = 0; i < hljsElements.length; i++) {
        const hljsElement = hljsElements[i];
        //   // 判断当前元素下是否存在.line-num-box元素
        const lineNumBoxElement = hljsElement.querySelector('.line-num-box');
        if (!lineNumBoxElement) {
            const code = elem.querySelectorAll('pre code');
            code.forEach((item) => {
                console.log(item, 4122123);
                console.log(item.offsetHeight, 4122123);

                // let pre = item.parentElement;
                // 新建元素 代码块序号

                let lineNumBox = document.createElement('div');
                lineNumBox.setAttribute('style', 'height: ' + item.offsetHeight + 'px');
                lineNumBox.setAttribute("style", "float: left;  padding:0 5px; border-right: 1px solid #ccc;  margin-right: 5px;font-size:18px");

                lineNumBox.className = 'line-num-box';
                let num = '';  // 设行高二十
                for (let i = 1; i <= Math.ceil(item.offsetHeight / 26); i++) {
                    num += i + '\n'; // 序号加上换行符
                }
                lineNumBox.innerText = num;// 插入序号
                item.parentElement.insertBefore(lineNumBox, item);

            })
        }
    }



}
export default getcode;